import React from 'react'
import { LOCALE } from 'src/dataLayer/env'
import { trackGuiInteracted } from 'src/dataLayer/remoteData/babbelEventStream'
import { Footer } from 'src/viewLayer/components/DesignSystem'

import { FooterContainer } from './index.styled'

// eslint-disable-next-line import/no-dynamic-require -- Legacy
const footerContent = require(`src/viewLayer/assets/translatedFooterContent/${LOCALE}.json`)

const handleFooterLinkClick = (footerLinkId) => {
  trackGuiInteracted({ guiElementName: footerLinkId })
}

export default () => (
  <FooterContainer>
    <Footer color="transparent">
      {Object.entries(footerContent).map(([sectionName, sectionLinks]) => (
        <Footer.Section key={sectionName} sectionName={sectionName}>
          {sectionLinks.map((sectionLinkData) => (
            <Footer.Item key={sectionLinkData.id}>
              <Footer.Link
                {...sectionLinkData}
                onClick={handleFooterLinkClick}
                sectionName={sectionName}
              >
                {sectionLinkData.title}
              </Footer.Link>
            </Footer.Item>
          ))}
        </Footer.Section>
      ))}
    </Footer>
  </FooterContainer>
)
